export default __webpack_public_path__ + "static/media/gray.140d749a.jpg";